import { jsx as _jsx } from "react/jsx-runtime";
import IcoMoon from "react-icomoon";
import { Icon as IconContainer } from "./styled";
import icomoonSet from "../../assets/selection.json";
export const Icon = ({ iconSet, size, onClick, id, ...rest }) => (_jsx(IconContainer, { onClick: onClick, id: id, children: _jsx(IcoMoon, { iconSet: iconSet ?? icomoonSet, size: size ?? 16, ...rest }) }));
